<template>
  <Transition
    :css="false"
    @before-enter="
      (el: Element) => {
        gsap.set(el, { opacity: 0 })
      }
    "
    @enter="
      (el: Element, done: () => void) => {
        gsap.to(el, { autoAlpha: 1, duration: 0.3, onComplete: () => done() })
      }
    "
    @leave="
      (el: Element, done: () => void) => {
        gsap.to(el, { autoAlpha: 0, duration: 0.1, onComplete: () => done() })
      }
    "
  >
    <slot />
  </Transition>
</template>

<script setup lang="ts">
const { gsap } = useGsap()
</script>
